var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6654 5.83325V5.83325C11.6654 5.3686 11.6654 5.13627 11.6269 4.94307C11.4691 4.14969 10.8489 3.52949 10.0555 3.37168C9.86235 3.33325 9.63002 3.33325 9.16536 3.33325H7.33203C5.44641 3.33325 4.5036 3.33325 3.91782 3.91904C3.33203 4.50482 3.33203 5.44763 3.33203 7.33325V9.16659C3.33203 9.63124 3.33203 9.86357 3.37046 10.0568C3.52827 10.8501 4.14847 11.4703 4.94185 11.6282C5.13505 11.6666 5.36738 11.6666 5.83203 11.6666V11.6666",
    stroke: "#141414"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.33203,
    y: 8.33325,
    width: 8.33333,
    height: 8.33333,
    rx: 2,
    stroke: "#141414"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlack);
export default __webpack_public_path__ + "static/media/copy_black.7e7b133735bbe52eb4f7a25b70520d19.svg";
export { ForwardRef as ReactComponent };